module.exports = __webpack_public_path__ + "static/img/42.02d062c5.gif";